<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        :title="title"
        color="primary"
      >
        <slot />
      </base-info-card>

      <template v-for="({ icon, text, title: t }, i) in business">
        <base-avatar-card
          :key="i"
          :icon="icon"
          :outlined="false"
          :title="!dense ? t : undefined"
          color="transparent"
          horizontal
          space="0"
        >
          <!-- Do not use v-html for user -->
          <!-- provided values -->
          <div v-html="text" />
        </base-avatar-card>

        <v-divider
          v-if="i + 1 !== business.length"
          :key="`divider-${i}`"
          class="my-2"
        />
      </template>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessContact',

    props: {
      dark: Boolean,
      dense: Boolean,
      title: String,
    },

    data: () => ({
      business: [
        {
          icon: 'mdi-map-marker-outline',
          title: 'Adress',
          text: 'Avtala Sverige AB<br>Gransbergsvägen 18<br>139 73 Djurhamn',
        },
        {
          icon: 'mdi-cellphone',
          title: 'Telefon',
          text: '<a style="color:inherit" href="tel:+46705599955">070 - 559 99 55</a><br><a style="color:inherit" href="tel:+46705551924">070 - 555 19 24</a>',
        },
        {
          icon: 'mdi-email',
          title: 'E-post',
          text: '<a style="color:inherit" href="mailto:info@avtala.se?subject=Kontakt">info@avtala.se</a><br><a style="color:inherit" href="mailto:support@avtala.se">support@avtala.se</a>',
        },
      ],
    }),
  }
</script>
